<template>
    <el-drawer
        :title="id ? '编辑展示计划' : '新增展示计划'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                v-if="formData"
                :model="formData"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="daterange" label="计划生效:" :rules="[{required: true, message: '请选择计划生效日期'}]">
                    <el-date-picker v-model="formData.daterange" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" unlink-panels size="medium"></el-date-picker>
                </el-form-item>
                <el-form-item prop="dateType" label="展示日期:">
                    <el-radio-group v-model="formData.dateType" size="medium" @change="formData.dateValue = []">
                        <el-radio :label="1" border>每天</el-radio>
                        <el-radio :label="2" border>每周</el-radio>
                        <el-radio :label="3" border>每月</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="formData.dateType == 2" prop="dateValue" :rules="[{required: true, message: '请选择每周展示的日期'}]" :show-message="formData.dateType == 2 ? true : false">
                    <el-checkbox-group v-model="formData.dateValue" size="medium">
                        <el-checkbox v-for="(item,index) in week" :key="index" :label="item.value">周{{item.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item v-if="formData.dateType == 3" prop="dateValue" :rules="[{required: true, message: '请选择每月展示的日期'}]" :show-message="formData.dateType == 3 ? true : false">
                    <el-checkbox-group v-model="formData.dateValue" size="medium">
                        <el-checkbox v-for="(item,index) in month" :key="index" :label="item">{{item == 32 ? '最后一天' : item}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item prop="timerange" label="展示时间:" :rules="[{required: true, message: '请选择展示时间范围'}]">
                    <el-time-picker v-model="formData.timerange" is-range start-placeholder="开始时间" end-placeholder="结束时间" size="medium" value-format="HH:mm:ss"></el-time-picker>
                </el-form-item>
                <el-form-item prop="showApproval" label="展示对象:" :rules="[{required: true, message: '请选择展示对象'}]">
                    <el-checkbox-group v-model="formData.showApproval" size="medium">
                        <el-checkbox label="2">报批申请中的演出</el-checkbox>
                        <el-checkbox label="3">还未申请报批的演出</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item prop="exclCityStatus" label="展示范围:" >
                    <el-radio-group v-model="formData.exclCityStatus" size="medium" @change="changeExclCityStatus">
                        <el-radio :label="0" border>全国</el-radio>
                        <el-radio :label="2" border>仅这些城市展示</el-radio>
                        <el-radio :label="1" border>仅这些城市不展示</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="formData.exclCityStatus != 0" prop="exclCity" :rules="[{required: true, message: '请选择城市'}]" :show-message="formData.exclCityStatus != 0 ? true : false">
                    <el-cascader
                        v-model="formData.exclCity"
                        :options="cityList"
                        filterable
                        :props="{label:'name',children:'cityList',value:'id',emitPath:false,multiple:true}"
                        :show-all-levels="false"
                        size="medium"
                        style="width:100%">
                    </el-cascader>
                </el-form-item>
                <el-form-item prop="showTerminal" label="展示终端:" :rules="[{required: true, message: '请选择展示终端'}]">
                    <el-checkbox-group v-model="formData.showTerminal" size="medium">
                        <el-checkbox v-for="(item,index) in terminal" :key="index" :label="item.value">{{item.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item prop="remark" label="备注:">
                    <el-input v-model="formData.remark" type="textarea" :rows="2" placeholder="请输入备注" maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="onSubmit()" :loading="btnLoading">保 存</el-button>
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'

const defaultFormData = {
    dateType: 1,
	dateValue: [],
	endDate: "",
	endTime: "",
	exclCity: [],
	exclCityStatus: 0,
	remark: "",
	showApproval: [],
	showTerminal: [],
	startDate: "",
    startTime: "",
    daterange:[],
    timerange:['00:00:00','23:59:59'],
    id:''
}
export default {
    data(){
        return{
            drawerShow: false,
            dataLoading:false,
            btnLoading:false,
            id:'',
            formData:{
                ...defaultFormData
            },
            week:[{
                label:'一',
                value:'1'
            },{
                label:'二',
                value:'2'
            },{
                label:'三',
                value:'3'
            },{
                label:'四',
                value:'4'
            },{
                label:'五',
                value:'5'
            },{
                label:'六',
                value:'6'
            },{
                label:'日',
                value:'7'
            }],
            month: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','35','26','27','28','29','30','31','32'],
            cityList:[],//所有省份城市集合
            terminal: [{
                label:'APP',
                value:'1',
            },{
                label:'WAPCN及所有小程序',
                value:'2',
            },{
                label:'WAPEN',
                value:'3',
            },{
                label:'PC',
                value:'4',
            }]
        }
    },
    created(){
        this.getCityList();
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            if(id){
                this.getData();
            }
            this.drawerShow = true;
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //获取详情
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/activityShowPlan/detail',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            daterange: result.startDate ? [result.startDate,result.endDate || result.startDate] : [],
                            dateValue: result.dateValue ? result.dateValue.split(',') : [],
                            timerange: result.startTime ? [result.startTime,result.endTime || result.startTime] : [],
                            showApproval: result.showApproval ? result.showApproval.split(',') : [],
                            exclCity: result.exclCity ? result.exclCity.split(',') : [],
                            showTerminal: result.showTerminal ? result.showTerminal.split(',') : [],
                        }
                        // this.formData.exclCity.map( (v,i) => {
                        //     this.formData.exclCity[i] = parseInt(v);
                        // });

                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        changeExclCityStatus(){
            this.formData.exclCity = this.formData.exclCity.length == 1 && this.formData.exclCity[0] == 0 ? [] : this.formData.exclCity;
        }, 
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.formData.startDate = this.formData.daterange[0];
                    this.formData.endDate = this.formData.daterange[1];
                    this.formData.startTime = this.formData.timerange[0];
                    this.formData.endTime = this.formData.timerange[1];
                    
                    this.btnLoading = true;
                    
                    this.$request({
                        url: '/activityShowPlan/addOrUpdate',
                        method: "POST",
                        data: {
                            ...this.formData,
                            dateValue: this.formData.dateValue.join(),
                            showApproval: this.formData.showApproval.join(),
                            exclCity: this.formData.exclCityStatus == 0 ? 0 : this.formData.exclCity.join(),
                            showTerminal: this.formData.showTerminal.join(),
                            id: this.id,
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$message.success("操作成功");
                                this.close();
                                this.$emit('onUpdate');
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });

                }else{
                    return false;
                }
            })    
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer{
    min-width: 680px;
}
</style>